import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const settingsReportSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.SETTINGS_REPORT_SAVE}`,
        popover: {
            title: "Save Report Settings",
            description:
                "Once you've made changes to recipients, click Save to apply them. Changes take effect for the next scheduled report.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SETTINGS_REPORT_LIST}`,
        popover: {
            title: "Email Recipients",
            description:
                "Manage email recipients for automated game reports. Add, edit, or remove email addresses that will receive post-match reports.",
        },
    },
];
